import PropTypes from 'prop-types';

import BuyButtonLayout from 'components/BuyButtonLayout';
import { addProductToBasket } from 'store/common/basket/actions';
import { addToCartProductDay } from 'store/SharedZone/actions';
import * as SharedZoneProductGoods from 'store/SharedZone/blocks/goods/selectors';

const mapStateToProps = (state) => ({
  goodDayProduct: SharedZoneProductGoods.getGoodProduct(state),
  isInBasket: SharedZoneProductGoods.getIsInBasket(state),
  isPreorder: SharedZoneProductGoods.getIsPreorder(state),
  isWide: true,
  productId: SharedZoneProductGoods.getProductId(state),
});

const mapDispatchToProps = {
  onClick: addProductToBasket,
  onClickEvent: addToCartProductDay,
};

const mergeProps = (
  { goodDayProduct, href, isInBasket, isPreorder, ...mapProps },
  { onClick, onClickEvent, onClickPreorder, ...dispatchProps },
  { isMobile, productId, source, ...ownProps },
) => ({
  ...ownProps,
  ...mapProps,
  ...dispatchProps,
  goodDayProduct,
  isInBasket,
  ...(isPreorder && !isInBasket ?
    {
      href,
      onClick: () => {
        onClickEvent(goodDayProduct);
      },
    }
  : {
      onClick: () => {
        onClickEvent(goodDayProduct);
        onClick({
          brand: goodDayProduct.brand,
          categoryId: goodDayProduct.categoryId,
          price: goodDayProduct.price.value,
          productId,
          source,
        });
      },
    }),
});

const BuyButton = SharedZoneProductGoods.connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps,
)(BuyButtonLayout);

BuyButton.propTypes = {
  className: PropTypes.string,
  href: PropTypes.string,

  /** component props */
  id: PropTypes.number,
  /** passed from redux */
  isInBasket: PropTypes.bool,
  isPreorder: PropTypes.bool,
  isWide: PropTypes.bool,
  onClick: PropTypes.func,
  onClickEvent: PropTypes.func,
};

export default BuyButton;
